// extracted by mini-css-extract-plugin
export default {"footer":"src-components-common-Footer-index__footer--shom5"};